/**
 * @Author Valon.Ye
 * @Date 2022/06/15 15:54:54
 * @FilePath \commerce\src\models\account.ts
 * @Description
 */
import { useCallback, useState } from 'react'
import { useFetch } from '@/utils/hooks'
import { setLocale, getLocale } from 'umi'

import StorageMap from '@/utils/storageMap'
import { useLocalStorageState } from 'ahooks'
import type { AccountProfileResponse } from '@/api-auto-gen/account'
import { AccountControllerApiParamCreator } from '@/api-auto-gen/account'

type IAccountProfile = AccountProfileResponse & {
  currencyChart: string
}

export default function useAccount() {
  const [assetId, setAssetId] = useState<string>()

  const [localAccountInfo, setLocalAccountInfo] = useLocalStorageState<IAccountProfile>(
    StorageMap.ACCOUNT_INFO,
  )

  const getAccountInfo = useFetch<
    BasicResponse<IAccountProfile>,
    [boolean | void],
    IAccountProfile | undefined,
    IAccountProfile
  >(AccountControllerApiParamCreator.getProfileUsingGET, {
    formatResult(res) {
      return {
        ...res.data,
        currencyChart: '￥',
      }
    },
    manual: true,
    onSuccess(data, [force]) {
      setLocalAccountInfo(data)
      const defaultLanguage = data?.language?.replace('_', '-')
      const locale = window.localStorage.getItem('umi_locale') || getLocale()
      if (defaultLanguage) {
        if (locale === defaultLanguage) {
          return
        }
        if (!force) {
          setLocale(defaultLanguage, false)
          return
        }
        setLocale(defaultLanguage)
      }
    },
  })

  const refreshAccountInfo = useCallback((force?: boolean) => {
    return getAccountInfo.run(force)
  }, [])

  const clearAccountInfo = useCallback(() => {
    setLocalAccountInfo({} as IAccountProfile)
  }, [])

  return {
    assetId,
    setAssetId,
    accountInfo: localAccountInfo,
    refreshAccountInfo,
    clearAccountInfo,
    loading: getAccountInfo.loading,
    accountInfoError: getAccountInfo.error,
  }
}
